// extracted by mini-css-extract-plugin
export var container = "more-post-module--container--RUUbN";
export var left = "more-post-module--left--PLJQz";
export var right = "more-post-module--right--0lfSx";
export var title = "more-post-module--title--CSeEm";